import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import PunkGenerator from '../views/PunkGenerator.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/punks',
    name: 'PunkGenerator',
    component: PunkGenerator
  },
  {
    path: '*',
    redirect: '/'
  }
]

// the site used hash routing back when it was served from IPFS,
// so rewrite old shared links like /#/punks to /punks before the router reads the URL
if (window.location.hash.startsWith('#/')) {
  window.history.replaceState(null, '', window.location.hash.slice(1))
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
